import Axios from "axios";
import { useEffect, useReducer } from "react";
import { systemCode, xs_languageCode, xs_product_code } from '..';
import { dataFetchReducer } from "./utils/dataFetchReducer";
import { mergeSeoConfigs } from "./seo/seoUtils";
import { getConfiguration } from './utils/configuration';

export function useFetchSeoSettings(path,isMobile,shouldExecute) {
    const [state, dispatch] = useReducer(dataFetchReducer, {
        isLoading: true,
        isError: false,
    });
    
    useEffect(() => {
        if (!shouldExecute) {
            return;
        }
        let didCancel = false;
        const fetchData = async (url, params, callback) => {
            dispatch({ type: 'FETCH_INIT' });
            try {
                const result = await Axios.get(url, {params});
                if (!didCancel) {
                    callback(result.data);
                }
            } catch (error) {
                console.error('Errore ' + url + ': ' + error);
                if (!didCancel) {
                    dispatch({ type: 'FETCH_FAILURE' });
                }
            }
        };
        
        //const url = window.XSPORT_PUBLIC_URL+'/contenuti_seo/getSeoSettings.json'
        //const url ='http://localhost:8083/XSeo/xsport/getSeoSettings'
        const url = getConfiguration().api.getSeoSettings;
        const params = {
            codiceProdotto: xs_product_code,
            hash: '',
            pathname:path,
            absolutePathname: window.location.pathname
        };
        path && fetchData(url, params, function(response) {
            const seoConfig = getSeoConfigData(response,path);
            var data = seoConfig || undefined;
            dispatch({ type: 'FETCH_SUCCESS', payload: data });
        });

       
        
        return () => {
            didCancel = true;
        };
    }, [path]);

    return [state, dispatch];
}

function getSeoConfigData(response,path){
    var seoConfig = undefined;
    try {
        if(response['seo_by_sc_lang']){
            seoConfig = {};
            var seoConfBySysCode = response['seo_by_sc_lang'][systemCode] || {};
            if(seoConfBySysCode){
                seoConfBySysCode['html'] = {};
            }
            if( seoConfBySysCode && seoConfBySysCode['html']){
                seoConfBySysCode['html'][path] = response['seo_by_sc_lang'][systemCode] && response['seo_by_sc_lang'][systemCode][xs_languageCode];
            }
            var seoConfBysCodeDefault = {};
            seoConfBysCodeDefault['html'] = {};
            seoConfBysCodeDefault['html'][path] =  response['seo_by_sc_lang']['DEFAULT'] && response['seo_by_sc_lang']['DEFAULT'][xs_languageCode];

            var mergedSeoConfig  =  seoConfBysCodeDefault['html'][path]?mergeSeoConfigs(seoConfBysCodeDefault,seoConfBySysCode):seoConfBySysCode;

            if(response['seo_brd_by_sc_lang']){
                var seoConfBrdBySysCode = response['seo_brd_by_sc_lang'][systemCode] || {};
                if(seoConfBrdBySysCode){
                    seoConfBrdBySysCode['html'] = {};
                }
                if( seoConfBrdBySysCode && seoConfBrdBySysCode['html']){
                    seoConfBrdBySysCode['html'][path] = response['seo_brd_by_sc_lang'][systemCode] && response['seo_brd_by_sc_lang'][systemCode][xs_languageCode];
                }
                var seoConfBrdBysCodeDefault = {};
                seoConfBrdBysCodeDefault['html'] = {};
                seoConfBrdBysCodeDefault['html'][path] =  response['seo_brd_by_sc_lang']['DEFAULT'] && response['seo_brd_by_sc_lang']['DEFAULT'][xs_languageCode];

                var mergedSeoConfigBrd  =  seoConfBrdBysCodeDefault['html'][path]?mergeSeoConfigs(seoConfBrdBysCodeDefault,seoConfBrdBySysCode):seoConfBrdBySysCode;

                mergedSeoConfig = mergeSeoConfigs(mergedSeoConfig,mergedSeoConfigBrd);
            }


            seoConfig['seo'] = mergedSeoConfig && mergedSeoConfig['html'] && mergedSeoConfig['html'][path];
        }
    }catch(err){
        console.log(err);
    }

    return seoConfig;
}
